import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from '../ui/button';
import { useAdminTheme } from '../../context/AdminThemeContext';

const AdminThemeToggle = ({ className }) => {
  const { isDark, toggleTheme } = useAdminTheme();

  return (
    <Button
      type="button"
      variant="outline"
      size="icon"
      onClick={toggleTheme}
      className={className}
      aria-label={isDark ? 'Açık moda geç' : 'Gece moduna geç'}
      title={isDark ? 'Açık mod' : 'Gece modu'}
    >
      {isDark ? <Sun size={18} /> : <Moon size={18} />}
    </Button>
  );
};

export default AdminThemeToggle;
